/**
 * Created by piotr.pozniak@thebeaverhead.com on 21/10/2024
 */

import React, { useMemo } from "react";
import WebsiteMissingWarning from "../../WebsiteMissingWarning";
import WebsitesVerifiedInfo from "../../WebsiteVerifiedInfo";
import InstallAccordion from "../../InstallAccordion";
import ClipboardCopyInput from "../../../../component/ClipboardCopyInput";
import {
  getInstallDivTag,
  installAlertsScripTag,
} from "../../../../templates/WidgetPageTemplate/InstallTab/helpers";
import appConfig from "../../../../../../appConfig";
import OneTimerAlert from "./OneTimerAlert";

const SquareSpaceInstructions = ({
  uuid,
  slug,
  widgetType,
  widgetTypePrintable,
  onGoToAddWebsite,
}) => {
  const installDiv = useMemo(
    () => getInstallDivTag(widgetType, uuid),
    [widgetType, uuid]
  );
  return (
    <div>
      {/*<FeatureFlag name={"squarespace-embeddable"}>
        <div className={"w-100 d-flex align-items-center flex-column"}>
          <p className={"text-center"}>
            Watch our tutorial video below or{" "}
            <a
              target={"_blankWordpressInstructions"}
              href={
                "https://help.display.church/en/articles/6750477-squarespace-embedding-your-view"
              }
            >
              Read our Article
            </a>
            .
          </p>
          <div className={"install-modal--video-tutorial"}>
            <div>
              <iframe
                src="https://player.vimeo.com/video/773599015?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                title="Embedding into Wordpress"
              ></iframe>
            </div>
            <script src="https://player.vimeo.com/api/player.js"></script>
          </div>
        </div>
      </FeatureFlag>*/}

      <div className={"my-4"}>
        <WebsiteMissingWarning onAddWebsite={onGoToAddWebsite} />
        <WebsitesVerifiedInfo />
      </div>
      <InstallAccordion
        title={`Installing ${appConfig.displayName} on SquareSpace`}
        defaultExpanded={true}
        expandable={false}
      >
        <div className={"alert alert-info"}>
          If you are using an older version of SquareSpace, the path to your
          Code Injection might look a little different.{" "}
        </div>
        <OneTimerAlert />
        <ol>
          <li>
            In SquareSpace, click on <strong>Settings</strong>.
          </li>
          <li>
            Within the Settings menu, click on <strong>Advanced</strong>.
          </li>

          <li>
            Within the Advanced Settings menu, click on{" "}
            <strong>Code Injection</strong>.
          </li>
          <li>
            Copy and Paste the following snippet into the{" "}
            <strong>HEADER</strong> section.
            <ClipboardCopyInput
              id={"embeddable_script"}
              value={installAlertsScripTag}
              placeholder={"Calendar embeddable script"}
            />
          </li>
          <li>
            Click <strong>Save</strong> to confirm your changes.
          </li>
        </ol>
      </InstallAccordion>
    </div>
  );
};

export default SquareSpaceInstructions;
